var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.986 0.000313072C22.4326 0.000313072 21.0307 0.902353 20.3794 2.30432L15.1187 13.5263L3.39533 15.2799C1.1907 15.63 -0.261753 17.6344 0.039462 19.8389C0.189291 20.64 0.540913 21.4427 1.14178 22.0435L9.75866 30.8604L7.70538 43.3344C7.35526 45.4886 8.80769 47.5434 11.0123 47.9438C11.9144 48.0937 12.8164 47.9438 13.5671 47.4928L23.9863 41.6814L34.4071 47.4423C36.361 48.4942 38.766 47.7925 39.8177 45.889C40.2687 45.0879 40.4186 44.1858 40.2687 43.2838L38.2154 30.8098L46.7818 22.0434C48.3352 20.49 48.2847 17.9353 46.7313 16.3819C46.1305 15.781 45.3783 15.4294 44.5267 15.2796L32.8034 13.4755L27.5932 2.30401C26.9418 0.90204 25.5399 0 23.9866 0L23.986 0.000313072Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.717c540c982c4b75d850975847e77727.svg";
export { ForwardRef as ReactComponent };